import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faGlobe } from "@fortawesome/free-solid-svg-icons/faGlobe";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ThemeToggle } from "components/Common/ThemeToggle";
import { useAppDispatch, useAppSelector } from "eduid-hooks";
import { AVAILABLE_LANGUAGES, LOCALIZED_MESSAGES } from "globals";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router";
import { updateIntl } from "slices/Internationalisation";
import { EduIDButton } from "./EduIDButton";
export const Footer = () => {
    const currentLocale = useAppSelector((state) => state.intl.locale);
    const dispatch = useAppDispatch();
    const messages = LOCALIZED_MESSAGES;
    let translateTo = [];
    let locale = "";
    let language = "";
    /* Figure out the locale and name of the _other_ language
     * (when Swedish is selected, show option to change to English).
     * TODO: Obviously only works when there are a total of two different languages here.
     */
    if (AVAILABLE_LANGUAGES !== undefined) {
        /* Filter out all the available languages _except_ the currently used one */
        translateTo = Object.entries(AVAILABLE_LANGUAGES).filter(([_locale]) => _locale !== currentLocale);
        /* Offer the user the choice to switch to the other language below */
        locale = translateTo[0][0];
        language = translateTo[0][1];
    }
    const changeLanguage = () => {
        if (locale) {
            dispatch(updateIntl({
                locale: locale,
                messages: messages[locale],
            }));
        }
    };
    return (_jsxs("footer", { id: "footer", children: [_jsxs("div", { className: "logo-wrapper", children: [_jsx("a", { href: "https://www.sunet.se/", "aria-label": "Sunet.se", title: "Sunet.se", target: "_blank", rel: "noreferrer", children: _jsx("div", { className: "sunet-logo" }) }), _jsx("span", { children: "\u00A92013-2026" })] }), _jsx(ThemeToggle, {}), _jsx("nav", { children: _jsxs("ul", { children: [_jsx("li", { children: _jsx(Link, { className: "help-link", to: "/help", target: "_blank", children: _jsx(FormattedMessage, { id: "common.help", defaultMessage: "Help", description: "Footer help" }) }) }), _jsx("li", { id: "language-selector", children: _jsx("span", { className: "lang-selected", "data-lang": locale, children: _jsxs(EduIDButton, { buttonstyle: "link normal-case", onClick: changeLanguage, children: [_jsx(FontAwesomeIcon, { icon: faGlobe }), language] }) }) })] }) })] }, "0"));
};
